import { SkeletonItem } from '@capsicum/common-web';
import styled from 'styled-components';

export type ChipsSkeletonProps = {
	items: number;
	testID: string;
};

export const ChipsSkeletons = ({ items, testID }: ChipsSkeletonProps) => {
	return (
		<S.ChipSkeletonWrapper>
			{Array(items)
				.fill(0)
				.map((_, index) => (
					<S.ChipSkeletonItem
						height={32}
						key={`${testID}-chips-skeleton-${index}`}
						testID={`${testID}-chips-skeleton-${index}`}
						width={60}
					/>
				))}
		</S.ChipSkeletonWrapper>
	);
};

namespace S {
	export const ChipSkeletonWrapper = styled.div`
		display: flex;
		align-items: center;
	`;

	export const ChipSkeletonItem = styled(SkeletonItem)`
		${({ theme }) => theme.border.radius.large};
		margin-right: ${({ theme }) => theme.spacings.xsmall};
	`;
}
